<template>
    <router-view></router-view>
</template>

<script>
export default {
  name: "OsobaDodatnaAktivnostBase"
};
</script>

<style scoped>

</style>
